import React, { useState } from 'react';
import { FaGithub } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { SiGoogledocs } from "react-icons/si";
import { MdEmail } from "react-icons/md";
import config from '../config';

function SocialLinks() {
  const { github, linkedin, x } = config.socialLinks;
  const { resumeLink } = config;
  const email = config.personalInfo.emails[1];
  const [showTooltip, setShowTooltip] = useState(false);

  const handleEmailClick = (e) => {
    e.preventDefault();
    navigator.clipboard.writeText(email);
    setShowTooltip(true);
    setTimeout(() => setShowTooltip(false), 2000); 
  };
  
  return (
    <div className="social-links">
      <a href={github} target="_blank" rel="noopener noreferrer" aria-label="GitHub">
        <FaGithub />
      </a>
      <a href={linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
        <FaLinkedin />
      </a>
      {/* <a href={x} target="_blank" rel="noopener noreferrer" aria-label="X">
        <FaXTwitter />
      </a> */}
      <a href={resumeLink} target="_blank" rel="noopener noreferrer" aria-label="Resume">
        <SiGoogledocs  />
      </a>
      <div className="tooltip-container">
        <button
          onClick={handleEmailClick}
          className="icon-button"
          aria-label="Copy email to clipboard"
        >
          <MdEmail />
        </button>
        {showTooltip && <div className="tooltip">Copied to clipboard!</div>}
      </div>
    </div>
  );
}

export default SocialLinks; 